import { Trans } from '../../components/i18n';
import Button from '../../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Wrapper component with fallback
const AuthIndexPage = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	document.title = `${t('general.app_name')} | ${t('general.login')}`;

	return (
		<div className='flex flex-col flex-1 justify-center items-center scroll-y gap-6'>
			<div>
				<img src='/images/Socrates_ikon.png' alt='Socrates illustration' className='max-h-80' />
			</div>

			<div className='flex flex-col max-w-md w-full'>
				<h3 className='text-3xl font-bold '>
					<Trans i18nKey='login.right_title' values={{ app_name: t('general.app_name') }} />
				</h3>
				<p className='text-sm text-gray-500 mt-3'>
					<Trans i18nKey='login.right_description' values={{ app_name: t('general.app_name') }} />
				</p>
				<div className='flex flex-col gap-4 mt-10'>
					<Button type='solid' size='large' variant='primary' onClick={() => navigate('/login/email')}>
						<Trans i18nKey='login.email_login' />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default AuthIndexPage;
